module.exports = __webpack_public_path__ + "static/img/userpop1.2ad4acd9.png";